var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRubyAlt2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_321)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_28_321)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.815 107.644L101.033 184.278L11.7916 107.714L87.619 133.444L188.815 107.644Z",
    fill: "url(#paint0_linear_28_321)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.785 134.681L100.825 184.347L59.1229 128.523L103.785 134.681V134.681Z",
    fill: "url(#paint1_linear_28_321)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.426 107.811L100.727 184.445L148.434 128.62L188.426 107.811V107.811Z",
    fill: "url(#paint2_linear_28_321)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.603 56.1009L188.37 107.894L133.06 78.4669L167.603 56.1009V56.1009Z",
    fill: "url(#paint3_linear_28_321)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.201 74.1854L103.924 134.82L69.2286 76.3261L135.201 74.1854V74.1854Z",
    fill: "url(#paint4_linear_28_321)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0086 80.2182L28.1663 118.695L34.0741 60.2154L72.0086 80.2182V80.2182Z",
    fill: "url(#paint5_linear_28_321)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.286 36.96L7.55192 67.9721L36.9516 59.5066L38.286 36.96Z",
    fill: "url(#paint6_linear_28_321)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.093 32.6367L189.301 62.8148L166.908 56.2955L156.093 32.6367V32.6367Z",
    fill: "url(#paint7_linear_28_321)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.982 31.6637L167.825 56.4344L133.505 78.1888L71.7306 80.4685L33.9907 60.7992L38.1608 36.5011L71.397 21.3634C86.1316 20.8073 114.92 20.0706 115.712 19.8065C116.504 19.5424 143.179 27.8132 155.982 31.6637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.421 21.4467C67.491 21.6275 36.5623 33.2066 36.6318 49.6231C36.7013 66.0397 65.4059 77.3964 98.2946 77.2574C131.183 77.1184 162.432 66.3038 162.404 49.8177C162.376 33.3317 133.324 21.2938 100.421 21.4467V21.4467Z",
    fill: "url(#paint8_linear_28_321)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.356 107.88L133.004 78.2167L104.091 134.514C133.95 133.569 163.335 128.592 188.356 107.88Z",
    fill: "url(#paint9_linear_28_321)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5778 80.4269L103.966 134.695C77.5551 134.027 51.4637 131.039 27.8745 118.765L71.5778 80.4269Z",
    fill: "url(#paint10_linear_28_321)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1386 118.806C10.5544 109.98 -9.39284 92.0895 7.71873 67.8609L33.9351 60.3546L28.1386 118.806Z",
    fill: "url(#paint11_linear_28_321)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.121 62.6342C210.305 85.0419 194.917 101.097 188.328 107.908L167.658 56.2955L189.121 62.6342Z",
    fill: "#AA3E35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6194 80.5797C67.7968 96.5515 60.0681 128.69 59.8874 129.315C59.6233 130.302 37.8689 124.478 28.2775 118.5L71.6194 80.5797Z",
    fill: "url(#paint12_radial_28_321)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.032 78.189L148.92 128.384C134.396 132.535 119.349 134.567 104.244 134.417L133.032 78.189Z",
    fill: "url(#paint13_radial_28_321)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.839 56.3371L199.212 82.8455C200.88 93.6879 195.126 100.555 188.022 106.685C180.878 89.9765 166.616 56.5874 167.839 56.3371Z",
    fill: "url(#paint14_linear_28_321)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1853 60.2434L4.88293 99.1093C-0.996992 89.5874 -0.385367 79.023 7.57964 67.9443L34.1853 60.2434Z",
    fill: "url(#paint15_linear_28_321)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_321",
    x1: 123.844,
    y1: 192.771,
    x2: 105.884,
    y2: 127.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68F71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DC5242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A72C32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72C32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_321",
    x1: 77.3743,
    y1: 169.654,
    x2: 87.3271,
    y2: 119.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B3F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A23E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A23E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28_321",
    x1: -4012.6,
    y1: 5978.7,
    x2: -4374.09,
    y2: 5465.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B3F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A23E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A23E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28_321",
    x1: 150.366,
    y1: 67.3047,
    x2: 176.124,
    y2: 102.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E28B6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DA6144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A60003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_28_321",
    x1: 89.6624,
    y1: 71.0995,
    x2: 119.034,
    y2: 103.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E08A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C14435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B13430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B13430"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_28_321",
    x1: 32.3365,
    y1: 70.9883,
    x2: 49.4342,
    y2: 98.4279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#DF8063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C94D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B13430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B13430"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_28_321",
    x1: 40.2738,
    y1: 47.3437,
    x2: 6.85689,
    y2: 58.4919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C94838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C12D2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C12D2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_28_321",
    x1: 162.112,
    y1: 40.0179,
    x2: 178.64,
    y2: 60.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DA6548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C14433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C14433"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_28_321",
    x1: 198.045,
    y1: 50.7352,
    x2: 23.2178,
    y2: 48.3026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#C95841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#983734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#AE4231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B93E2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DE4E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE4E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_28_321",
    x1: 140.969,
    y1: 125.687,
    x2: 160.513,
    y2: 93.3265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F3633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A73532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B13439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B13439"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_28_321",
    x1: 65.2114,
    y1: 139.115,
    x2: 67.6023,
    y2: 95.3839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#923C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#AA3531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA3531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_28_321",
    x1: 18.8114,
    y1: 109.674,
    x2: 18.019,
    y2: 85.8899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D3E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#AA3E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA3E37"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_28_321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.405 99.3872) rotate(135) scale(39.9654 39.9654)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#923934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923934"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_28_321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.788 97.4829) rotate(135) scale(53.1365 53.1365)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE3531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#953A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953A36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_28_321",
    x1: 196.363,
    y1: 99.818,
    x2: 173.969,
    y2: 58.6863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#994939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AA3A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B83936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B83936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_28_321",
    x1: 19.2839,
    y1: 66.3874,
    x2: 7.55184,
    y2: 96.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9392F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#A23A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8D463A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D463A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_28_321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.267,
    height: 157.267,
    fill: "white",
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 100.421 -26.0652)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubyAlt2);
export default __webpack_public_path__ + "static/media/ruby-alt2.b20ea8e9418defbb79f7bfac8db5b499.svg";
export { ForwardRef as ReactComponent };